import { getAuthenticated, patchAuthenticated, postAuthenticated, putAuthenticated } from './http';

export const fetchChatConversations = () => getAuthenticated('/api/chat/conversations');

export const fetchChatConversation = (conversationId) =>
  getAuthenticated(`/api/chat/conversations/${encodeURIComponent(conversationId)}`);

export const ensureDirectConversation = (userId) =>
  postAuthenticated('/api/chat/conversations/direct', { userId });

export const ensureFriendsConversation = () =>
  postAuthenticated('/api/chat/conversations/friends', {});

export const ensureNightConversation = (nightId) =>
  postAuthenticated(`/api/chat/conversations/night/${encodeURIComponent(nightId)}`, {});

export const fetchChatMessages = (conversationId, params = {}) =>
  getAuthenticated(`/api/chat/conversations/${encodeURIComponent(conversationId)}/messages`, {
    params,
  });

export const sendChatMessage = (conversationId, body, options = {}) =>
  postAuthenticated(`/api/chat/conversations/${encodeURIComponent(conversationId)}/messages`, {
    body,
    attachment: options.attachment || null,
    replyToMessageId: options.replyToMessageId || null,
  });

export const toggleChatMessageReaction = (conversationId, messageId, emoji) =>
  putAuthenticated(
    `/api/chat/conversations/${encodeURIComponent(conversationId)}/messages/${encodeURIComponent(
      messageId
    )}/reactions`,
    { emoji }
  );

export const markChatConversationRead = (conversationId) =>
  patchAuthenticated(`/api/chat/conversations/${encodeURIComponent(conversationId)}/read`, {});
